import PagesModel from '../Apis/Pages.js'
import Controller from './Controller.js';

export default class PagesController extends Controller {

    constructor() {
        super(new PagesModel());
    }


}